import Vue from 'vue'
import App from './App.vue'

import { store } from './store/store'

import * as Sentry from "@sentry/browser";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import * as Integrations from '@sentry/integrations';

Sentry.init({
  Vue,
  dsn: "https://cc6ea73fa2f44472bc92cd12bc95f672@sentry.sybrenromer.nl/3",
  autoSessionTracking: true,
  logError: true,
  tracingOptions: {
    trackComponents: true,
  },
  integrations: [
    new Integrations.Vue({Vue, attachProps: true}),
    new TracingIntegrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

new Vue({
  el: '#app',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js